import getClosestDate from './getClosestDate';
import existsIn from './existsIn';
import { ITrend, ITrendDataItem } from '../types';

/**
 * Retrieves datapoints from the passed trend data array that match the passed
 * period parameter, or are the closest date to the period parameter.
 *
 * @param  {Array} trends   Trend data
 * @param  {Date | null} period  Unix timestamp (in ms)
 * @return {Array}         Trend data points for the passed period
 */
function getTrendPoints(trends: ITrend[], period: Date | null): any {
  if (!trends || !period) return;

  const periodExists = existsIn(trends, period);

  if (periodExists) {
    trends.map((trend) => ({
      ...trend,
      data: trend.data.find(
        (d: ITrendDataItem) => d.date.getTime() === Number(period)
      ),
    }));
  }

  const closestDate = getClosestDate(period, trends);

  const trendPoints = trends.map((trend) => ({
    ...trend,
    data: trend.data.find(
      (d: ITrendDataItem) => d.date.getTime() === closestDate?.getTime()
    ),
  }));

  // Only return an array if there are values in it.
  return trendPoints.length ? trendPoints : undefined;
}

export default getTrendPoints;
